// Sandbox Interac e-Transfer integration (redirect-based mobile money).
// Stands in for the acquirer's hosted bank page: the tester picks an outcome, we finalize the
// transaction via the sandbox endpoint, then redirect back to the merchant's return URL.

import React, { useEffect, useState } from "react";
import "./interac.scss";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import PuffLoader from "react-spinners/PuffLoader";

const publicUrlSandbox = "https://sandbox.paydeca.com";
const publicUrlDev = "https://dev.veripaygate.com/api";

const ENVIRONMENT_TYPES = {
  SANDBOX: "sandbox",
  PRODUCTION: "production",
  DEVELOPMENT: "development",
};

const flows = [
  { flow: "Successful", status: "succeeded" },
  { flow: "Failed", status: "failed" },
];

function Interac() {
  const { txid } = useParams();

  const [decryptedData, setDecryptedData] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [publicUrl, setPublicUrl] = useState();
  const [processing, setProcessing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!txid) {
      toast.error("Invalid transaction id");
      return;
    }

    const url = new URL(window.location.href);
    const transaction = new URLSearchParams(url.search).get("transaction");

    if (!transaction) {
      toast.error("Invalid transaction id");
      return;
    }

    const bytes = CryptoJS.AES.decrypt(
      transaction.replace(/ /g, "+"),
      "sandbox-transaction"
    );
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedText) return;

    const _decryptedData = JSON.parse(decryptedText);
    let _publicUrl = publicUrlSandbox;
    if (_decryptedData.environment === ENVIRONMENT_TYPES.DEVELOPMENT)
      _publicUrl = publicUrlDev;

    setPublicUrl(_publicUrl);
    setDecryptedData(_decryptedData);
  }, [txid]);

  const handlePay = () => {
    if (!selectedStatus) return;
    setIsSubmitting(true);
    setProcessing(true);
    window.location.href = `${publicUrl}/fn-execute/payment/redirect?acq=sandbox&status=${selectedStatus}&oid=${txid}`;
  };

  return (
    <div className="interac">
      {processing ? (
        <PuffLoader color="#36d7b7" />
      ) : (
        <div className="container">
          <div className="header">
            <p>Interac e-Transfer (Sandbox)</p>
          </div>

          <div className="body">
            <div className="row th">
              <span>Flow</span>
              <span>Outcome</span>
            </div>
            {flows.map((el) => (
              <div
                key={el.status}
                className={`row ${el.flow} ${selectedStatus === el.status ? "selected" : ""
                  }`}
                onClick={() => setSelectedStatus(el.status)}
              >
                <span>{el.flow}</span>
                <span>{selectedStatus === el.status ? "●" : "○"}</span>
              </div>
            ))}
            <button onClick={handlePay} disabled={!selectedStatus || isSubmitting}>
              {isSubmitting ? (
                <div className="btn-spinner">
                  <PuffLoader className="btn-spinner-loader" />
                </div>
              ) : (
                `Pay ${decryptedData?.amount ?? ""} ${decryptedData?.currency ?? ""}`
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Interac;
